import { InjectionToken } from '@angular/core';

export const TRANSLATION_PRISMIC_TAG = new InjectionToken<string>('TRANSLATION_PRISMIC_TAG');

export const TRANSLATION_DYNAMIC_VALUES = new InjectionToken<{ [key: string]: string }>('TRANSLATION_DYNAMIC_VALUES');
